import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { KeyRound, Loader2, Save } from 'lucide-react';
import { notesApi } from '@/lib/notesApi';
import { extractError } from '@/lib/errors';

const URL = '/notes/tag-workspace/admin/unlock-phrases';
const IN = 'h-10 w-full rounded-lg border border-input bg-background px-3 text-sm text-foreground';

function Field({ label, hint, set, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold text-foreground">{label}</span>
      <span className="ml-2 text-[length:calc(var(--fs,1)*0.6875rem)] text-muted-foreground" data-testid={`${testid}-status`}>{set ? 'Set' : 'Not set'}</span>
      <input type="password" autoComplete="new-password" value={value} onChange={(e) => onChange(e.target.value)} maxLength={120} placeholder={set ? 'Type a new phrase to change it' : 'Type the phrase'} className={`${IN} mt-1`} data-testid={testid} />
      <span className="mt-1 block text-[length:calc(var(--fs,1)*0.6875rem)] text-muted-foreground">{hint}</span>
    </label>
  );
}

// Super admin: phrases typed on the maintenance page (full unlock / Sales & Approval mode).
export function TagUnlockPhrases() {
  const [data, setData] = useState(null);
  const [full, setFull] = useState('');
  const [part, setPart] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { notesApi.get(URL).then(({ data: d }) => setData(d)).catch((e) => toast.error(extractError(e, 'Could not load phrases'))); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data: d } = await notesApi.put(URL, { full: full || null, partial: part || null }); setData(d); setFull(''); setPart(''); toast.success('Unlock phrases saved.'); } catch (e) { toast.error(extractError(e, 'Could not save')); } finally { setBusy(false); }
  };
  if (!data) return <div className="grid h-40 place-items-center text-muted-foreground"><Loader2 className="animate-spin" size={18} /></div>;
  return (
    <div className="space-y-4" data-testid="tagws-unlock-phrases">
      <div>
        <div className="flex items-center gap-2 text-sm font-semibold text-foreground"><KeyRound size={16} /> Unlock phrases</div>
        <p className="mt-1 text-xs text-muted-foreground">Typed on the maintenance page when the portal is locked; the super admin email and password are then asked. The full unlock phrase also unlocks the portal from Sales &amp; Approval mode (type it anywhere on the main page). Phrases are stored securely and never shown.</p>
      </div>
      <Field label="Full unlock phrase" hint="Unlocks the whole portal." set={data.full_set} value={full} onChange={setFull} testid="tagws-phrase-full" />
      <Field label="Sales & Approval phrase" hint="Opens the portal in Sales & Approval mode only." set={data.partial_set} value={part} onChange={setPart} testid="tagws-phrase-partial" />
      <button type="button" onClick={save} disabled={busy || (!full && !part)} className="inline-flex h-9 items-center gap-1.5 rounded-lg bg-primary px-4 text-xs font-semibold text-primary-foreground hover:opacity-90 disabled:opacity-50" data-testid="tagws-phrases-save">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save phrases
      </button>
    </div>
  );
}
